/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
export { durations, durationStep } from './utils/durations';
export { exitingDurations } from './utils/exiting-durations';
export type { Durations } from './utils/durations';
export { easeIn, easeInOut, easeOut, linear } from './utils/curves';
export { isReducedMotion } from './utils/is-reduced-motion';
export { useIsReducedMotion } from './utils/use-is-reduced-motion';
export { prefersReducedMotion } from './utils/accessibility';
export { reduceMotionAsPerUserPreference } from './utils/reduce-motion-as-per-user-preference';
export { default as FadeIn } from './entering/fade-in';
export type { FadeKeyframesMotionProps } from './entering/fade-in';
export { default as AnimateIn } from './entering/animate-in';
export type { AnimateKeyframesMotionProps } from './entering/animate-in';
export { default as StaggeredEntrance } from './entering/staggered-entrance';
export type { StaggeredEntranceProps } from './entering/staggered-entrance';
export { ResizingHeight } from './resizing/height';
export { useResizingHeight } from './resizing/use-resizing-height';
export { default as ExitingPersistence } from './entering/exiting-persistence';
export { useExitingPersistence } from './entering/use-exiting-persistence';
export type { ExitingPersistenceProps } from './entering/exiting-persistence';
export { default as ZoomIn } from './entering/zoom-in';
export { default as SlideIn } from './entering/slide-in';
export { default as ShrinkOut } from './entering/shrink-out';
export type { ShrinkOutProps } from './entering/shrink-out';
export type { Transition, Direction } from './entering/types';
export { default as Motion, type MotionRef, type MotionProps } from './entering/motion';
export { Reanimate } from './entering/reanimate';
